import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { data } from "jquery";
import { Subject } from "rxjs";
import { MatDialog } from "@angular/material";

import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: "app-view-property",
  templateUrl: "./view-property.component.html",
  styleUrls: ["./view-property.component.scss"],
})
export class ViewPropertyComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  Data: any;
  UserID: any;
  inputValue: string = "";
  breadCrumbItems: Array<{}>;
  applicationData: any;
  baseURL: string;
  isLoading: boolean;
  Status: string;
  user: any;
  planId: any;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private datepipe: DatePipe,
    private gs: GeneralService,
    private http: HttpClient,
    public dialog: MatDialog
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.Userid;
        this.Status = a.state.Status;
        this.planId = a.state["PlanId"];
        localStorage.setItem("Status", this.Status);
        console.log("thisuserid", this.UserID);
        localStorage.setItem("id", this.UserID);
        // localStorage.setItem("PlanID", this.planId);
      }
    }
    if (localStorage.getItem("Status")) {
      this.Status = localStorage.getItem("Status");
    }
    if (localStorage.getItem("id")) {
      this.UserID = localStorage.getItem("id");
    }
    // console.log("UserID",this.UserID)
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "Properties", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    // console.log("UserId View Property",this.UserID)
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      // ordering: true,
      searching: true,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            // `${this.gs.getLawyer()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,

            `${this.gs.getPropertylist()}` +
              "?" +
              `${"UserID="}` +
              `${this.UserID}` +
              // `${this.inputValue != "" ? "&search=" + this.inputValue : ""}` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&search=" + dataTablesParameters.search.value
                  : ""
              }` +
              `${
                dataTablesParameters.order
                  ? "&orderKey=" +
                    dataTablesParameters.columns[
                      dataTablesParameters.order[0].column
                    ].name
                  : "&orderKey=id"
              }` +
              `${
                dataTablesParameters.order
                  ? "&ordering=" + dataTablesParameters.order[0].dir
                  : "&ordering=desc"
              }` +
              `${
                dataTablesParameters.length.value != ""
                  ? "&PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `&pageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }`,

            {}
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.Count,
              recordsFiltered: resp.Count,
              data: resp.result,
            });
          });
      },
      columns: [
        // {
        //   title: "Id",
        //   data: null,
        //   render: (data) => {
        //     return data.id ;
        //   },
        // },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (data.entrydate === "0000-00-00" || data.entrydate == null) {
              return "--";
            } else {
              return this.datepipe.transform(data.entrydate, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "Property Type",
          data: null,
          render: (data) => {
            // Rural / Urban / Both, derived from the stored location (which is
            // exactly what BaseDocumentType_Dynamic drove at save time): a
            // village id ⇒ rural side, a ward id ⇒ urban side. Robust for older
            // rows that predate BaseDocumentType_Dynamic.
            const hasVillage =
              data.village && data.village !== "null" && data.village != 0;
            const wardId =
              data.WardID || data.wardid || data.wardID || data.CityWardNo || data.ward;
            const hasWard = wardId && wardId !== "null" && wardId != 0;
            if (hasVillage && hasWard) { return "Both"; }
            if (hasWard) { return "Urban"; }
            if (hasVillage) { return "Rural"; }
            return "--";
          },
        },
        {
          title: "Village / Ward",
          data: null,
          render: (data) => {
            const clean = (parts) =>
              parts
                .filter(
                  (x) =>
                    x !== null && x !== undefined && x !== "" && x !== "null"
                )
                .join(", ");

            // Rural = village-based, Urban = ward-based. A "Both" base document
            // type property can carry either or both, so show whichever exist.
            // Urban-only rows have no village id, and the GET query COALESCEs
            // the ward name into `villagename` and the city survey office name
            // into `Talukaname` — so only treat the row as rural when the
            // village id itself is set.
            const hasVillage =
              data.village && data.village !== "null" && data.village != 0;
            const villageText =
              hasVillage && data.villagename
                ? clean([data.villagename, data.Talukaname, data.districtname])
                : "";

            // Ward may come back under a few different keys depending on the API.
            const wardId =
              data.WardID || data.wardid || data.wardID || data.CityWardNo || data.ward;
            const wardName =
              data.WardName || data.wardname || (!hasVillage ? data.villagename : "");
            const csoName =
              data.CitySurveyOfficeName ||
              data.citysurveyofficename ||
              (!hasVillage ? data.Talukaname : "");
            const wardText =
              wardId || wardName
                ? clean([wardName || (wardId ? "Ward " + wardId : ""), csoName, data.districtname])
                : "";

            if (villageText && wardText) {
              return `Village: ${villageText}<br>Ward: ${wardText}`;
            }
            return villageText || wardText || "--";
          },
        },
        {
          title: "Survey/CitySurvey No.",
          data: null,
          render: (data) => {
            // Rural stores the number in surveyno; Urban stores it in city_survey_no.
            const val =
              data.surveyno && String(data.surveyno).trim() !== ""
                ? data.surveyno
                : data.city_survey_no;
            return this.renderData(val);
          },
        },
        {
          title: "TP No.",
          data: null,
          render: (data) => {
            return this.renderData(data.tpno);
          },
        },
        {
          title: "FP No.",
          data: null,
          render: (data) => {
            return this.renderData(data.fpno);
          },
        },
        {
          title: "Building Name",
          data: null,
          render: (data) => {
            return this.renderData(data.societyname);
          },
        },
        {
          title: "Building No.",
          data: null,
          render: (data) => {
            return this.renderData(data.buildingno);
          },
        },
        // {
        //   title: "CSR Name",
        //   data: null,
        //   render: (data) => {
        //     return this.renderData(data.CSRName)
        //   },
        // },
        {
          title: "Action",
          name: "id",
          orderable: false,
          data: null,
          render(data) {
            return `<div style="display:flex" >
            <a class="btn text-primary edit" title="Edit Notice">
            <i class="btn font-18 mdi mdi-content-save-edit-outline text-secondary" UserId="${data.id}"></i></a>
            <a title="Delete Property"> <i style="display:flex;margin-top: 14px; cursor:pointer;font-size: 20px; color:#c20615"class="material-icons"  UserId="${data.id}">delete</i></a>

          `;
          },
        },
      ],
      drawCallback: () => {
        $(".edit").on("click", (e) => {
          this.router.navigate(["/users/property"], {
            state: {
              rowid: e.target.getAttribute("UserId"),
              Editproperty: true,
              editId: this.UserID,
            },
          });
        });
        // console.log("EditId",this.UserID)
        // $('.delete').on('click', (e) => {
        // this.gs.deletePropertylist
        // });

        $(".material-icons").on("click", (e) => {
          this.deleteDocument(e.target.getAttribute("UserId"));
        });
      },
    };
  }

  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanID", this.planId);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  ShowMessage() {
    return this.Status === "deactivated";
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  AddProperty() {
    this.router.navigate(["/users/property"], {
      state: { id: this.UserID, Editproperty: false },
    });
  }

  deleteDocument(id) {
    console.log("262", id);
    this.isLoading = true;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this property detail?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonClass: "btn btn-danger mt-2",
      cancelButtonClass: "btn btn-success ml-2 mt-2",
      buttonsStyling: false,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.gs.deletePropertylist(id).subscribe((res) => {
          console.log("Delete", res);
          Swal.fire({
            title: "Success",
            text: "Data Deleted successfully.",
            type: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.rerender();
          });
          // }
          this.isLoading = false;
        });
      }
    });
  }
  renderData(data) {
    if (data === "" || data === null || data === "null" || data == 0) {
      return "--";
    } else {
      return data;
    }
  }
}
